import { Button } from "@/components/ui/button";
import useErpUIController from "@/hooks/useGlobalContext";
import { isLoggedIn } from "@/lib/auth";
import { routes } from "@/app/routes/paths";
import { dashboardPath } from "@/app/routes/route";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";

// Custom error component
const CustomErrorPage = () => {
	const { controller } = useErpUIController();
	const { loggedInUser } = controller;

	const error = useRouteError();

	let status = 500;
	let title = "Oops! Something went wrong";
	let message = "We have encountered an unusual error. Our Engineers are currently working to resolve it as soon as possible";
	let image = "/assets/images/500.png"

	if (isRouteErrorResponse(error)) {
		status = error.status;

		if (status === 404) {
			title = "Oops! The page you're looking for got lost in space";
			message = "Don't worry, our engineers are boosting the signal to find this page. Meanwhile, you can explore other parts of the site!"
			image = "/assets/images/404.png"
		}

	} else if (error instanceof Error) {
		message = "We have encountered an unusual error. Our Engineers are currently working to resolve it as soon as possible";
	}

	return (
		<div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-red-50 to-pink-50 dark:from-gray-950 dark:to-gray-950  text-center">
			{/* Header Section */}
			<div className="space-y-4">
				<h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary to-red-600">
					{status}
				</h1>
				<p className="text-2xl md:text-3xl font-medium text-gray-800 dark:text-gray-400">
					{title}
				</p>
				<p className="text-lg text-gray-600 dark:text-gray-400 mb-10" dangerouslySetInnerHTML={{ __html: message }}></p>
			</div>

			{/* Illustration Section */}
			<div className="mt-8">
				<div className="relative mt-4">
					<div className="absolute inset-0 bg-gradient-to-r from-red-200 to-pink-200 rounded-full blur-xl opacity-50" />
					<img
						src={image}
						alt="Astronaut Lost in Space"
						className="relative z-10 w-64 h-64 object-cover rounded-full shadow-lg animate-pulse"
					/>
				</div>
			</div>

			{/* Call to Action Section */}
			<div className="mt-20 space-x-4">
				{loggedInUser && isLoggedIn() ? (
					<>
						<Button asChild size="lg">
							<Link to={dashboardPath}>Back to Dashboard</Link>
						</Button>
					</>
				) : (
					<Button asChild size="lg">
						<Link to={routes.LOGIN_PATH}>Back to Login</Link>
					</Button>
				)}
				<Button size="lg" variant="secondary">
					<a
						href="https://gcps.edu.gh"
						target="_blank"
						rel="noreferrer"
					>
						Explore More
					</a>
				</Button>
			</div>
		</div>
	);
};

export default CustomErrorPage;
